import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  biNotebookNotesByDateAndTagSuccess,
  biNotebookNotesByDateSuccess,
  biNotebookNotesByTagSuccess,
  setLoadingState,
} from './actions';

export default handleActions(
  {
    [biNotebookNotesByTagSuccess](state, { payload }) {
      return {
        ...state,
        byTag: payload,
      };
    },
    [biNotebookNotesByDateAndTagSuccess](state, { payload }) {
      return {
        ...state,
        byDateAndTag: payload,
      };
    },
    [biNotebookNotesByDateSuccess](state, { payload }) {
      return {
        ...state,
        byDate: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
